import React from 'react';
import PropTypes from 'prop-types';
import { ProTile } from '@thd-olt-component-react/project-summary';
import { projectPropType } from '../dataModel';

const { arrayOf, number, bool } = PropTypes;

const MobileCompactList = ({ projects, maxMobileProjectSize, isDashboardSnapshot }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mb-8">
      {projects && projects.slice(0, maxMobileProjectSize).map((project, index) => {
        return (
          <ProTile
            key={project.projectId}
            projectId={project.projectId}
            project={project}
            maxThumbnails={4}
            position={index + 1}
            isDashboardSnapshot={isDashboardSnapshot}
          />
        );
      })}
    </div>
  );
};

MobileCompactList.propTypes = {
  maxMobileProjectSize: number,
  projects: arrayOf(projectPropType),
  isDashboardSnapshot: bool,
};

MobileCompactList.defaultProps = {
  maxMobileProjectSize: 3,
  projects: [],
  isDashboardSnapshot: false,
};

export default MobileCompactList;
